var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripsMini = function SvgTripsMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 9.468V12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9.468zM8.769 1.01a1 1 0 0 1 1 1L9.768 4H12a1 1 0 0 1 1 1v2.968H1V5a1 1 0 0 1 1-1h2.268V2.01a1 1 0 0 1 1-1zm-.501 1.499h-2.5l-.001 1.49h2.5z"
  })));
};
export default SvgTripsMini;